import {Identifiable, WithStartDate} from './identifiable';

export interface Invoice extends Identifiable, WithStartDate {
  transactionsAmount: number;
  rewardsAmount: number;
  commissionAmount: number;
  status: InvoiceStatus;
}

export enum InvoiceStatus {
  ISSUED = 'ISSUED',
  PAID = 'PAID',
}
